module.exports = __webpack_public_path__ + "static/img/member_anka.20e71216.jpg";